enum SoftwarePackageCategory {
  Software = "1",
  Windows = "2",
  Language = "3"
}

export default SoftwarePackageCategory;
